import {
  Box,
  Button,
  FormHelperText,
  Grid,
  TextField,
  Typography,
} from "@mui/material";
import { Dispatch, SetStateAction } from "react";
import { BentoBrand } from "schemas/dashboard";
import { CustomEvent, Map } from "schemas/functions";

import DraftLoader from "features/Auth/Onboarding/EmailBrandForm/DraftLoader";
import styles from "features/Auth/Onboarding/styles";
import { makeDeepCopy } from "utils/updateLocalState";

interface StandOutFormProps {
  handleBack?: () => void;
  handleNext?: () => void;
  handleSkip?: () => void;
  onboardingForm: Map;
  setOnboardingForm: Dispatch<SetStateAction<Map>>;
  loading?: boolean;
  selectedBrand?: BentoBrand;
  isProfilePage?: boolean;
}

const StandOutForm = ({
  handleBack,
  handleNext,
  handleSkip,
  onboardingForm,
  setOnboardingForm,
  selectedBrand,
  loading = false,
  isProfilePage = false,
}: StandOutFormProps) => {
  const onSubmit = (e: CustomEvent) => {
    e.preventDefault();
    if (handleNext) handleNext();
  };

  const handleChange = (e: CustomEvent) => {
    const { name, value } = e.target;

    const copy = makeDeepCopy(onboardingForm);
    copy[name] = value;
    setOnboardingForm(copy);
  };

  return (
    <form onSubmit={onSubmit}>
      {!isProfilePage && (
        <>
          <Typography variant="h3" gutterBottom sx={{ textAlign: "center" }}>
            <Box
              component="i"
              color="secondary.dark"
              sx={{ pr: 2 }}
              className="fa-solid fa-hashtag"
            />
            {loading
              ? selectedBrand
                ? `Generating a pitch to ${selectedBrand?.brandName}`
                : `Generating your pitch template`
              : "What stands out about you"}
          </Typography>

          {!loading && (
            <Typography style={{ marginBottom: "16px" }}>
              Write a couple of bullet points about what makes you stand out as
              a creator! (e.g. your former career, the type of content you
              specialize in, unique skills you have, etc.)
            </Typography>
          )}
        </>
      )}
      {isProfilePage && (
        <FormHelperText sx={styles.helperText}>
          Many creators promise high-quality content, but what truly makes you
          stand out?
        </FormHelperText>
      )}
      {loading && (
        <Box sx={styles.templateWrapper}>
          <Box sx={styles.loaderWrapper}>
            <DraftLoader />
          </Box>
        </Box>
      )}

      {!loading && (
        <Grid sx={styles.fieldContainer}>
          <TextField
            sx={styles.textField}
            fullWidth
            name="standsOutDescription"
            multiline
            minRows={2}
            onChange={handleChange}
            value={onboardingForm?.standsOutDescription || ""}
          />
        </Grid>
      )}
      {!isProfilePage && (
        <Grid
          container
          justifyContent="flex-start"
          columnGap={1}
          sx={{ mt: 2 }}
        >
          <Grid item xs="auto">
            <Button onClick={handleBack} color="secondary" disableElevation>
              Back
            </Button>
          </Grid>
          <Grid item xs></Grid>
          {handleSkip && (
            <Grid item xs="auto">
              <Button onClick={handleSkip} color="secondary" disableElevation>
                Skip
              </Button>
            </Grid>
          )}
          <Grid item xs="auto">
            <Button
              disableElevation
              type="submit"
              variant="contained"
              disabled={loading}
            >
              Next
            </Button>
          </Grid>
        </Grid>
      )}
    </form>
  );
};

export default StandOutForm;
